
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/red-gold-case-study",
      function () {
        return require("private-next-pages/resources/red-gold-case-study.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/red-gold-case-study"])
      });
    }
  